import React, { useState, useEffect, Fragment }from 'react'
import { graphql } from 'gatsby'
import PropTypes from 'prop-types'
// import useSWR from 'swr'
// import { getData } from '../components/sfc/component-helpers/requesthelpers'
import Layout from '../components/layout'
import WCMImage from '../components/sfc/wcmimage'
import DropCap from '../components/sfc/dropcap'
import { useCanNativeLazyLoad } from '../components/sfc/component-helpers/customhooks'
import * as topperStyles from '../styles/modules/topper.module.less'
import RelatedSection from '../components/sfc/relatedsection'
import CreditsSection from '../components/sfc/creditssection'
import Ad from '../components/sfc/ad'
import BodyText from '../components/sfc/bodytext'
import { ConvertTimestamp } from '../components/sfc/component-helpers/convertTimestamp'
import {
  pubdateString,
  moddateString,
} from '../components/sfc/component-helpers/datehelpers'
// import Newsletter from '../components/sfc/newsletter'
import AthleteList from '../components/athletelist'
import SafeLink from '../components/sfc/safelink'
import Voting from '../components/voting'
import NavTop from '../components/sfc/navtop'
import SponsorBug from '../components/sfc/sponsorbug'
import HubPageCard from '../components/hubpagecard'
import  { GetBylineText } from '../components/sfc/component-helpers/getbylinetext'
import { applyScrollDepthTracking } from '../components/sfc/component-helpers/utilfunctions'
let storySettings = require('../data/story_settings.sheet.json')
let athlete_list = require('../data/athletes.sheet.json')
if(athlete_list[0].Name.includes("full name")){
  athlete_list.shift()
}
athlete_list = athlete_list.filter(i => i.Page_Date.length != 0)
let page_list = require('../data/page_settings.sheet.json')
if(page_list[0].Page_Title.includes("Title of the page")){
page_list.shift()
}
page_list = page_list.filter(i => i.Page_Title.length > 0)
page_list = page_list.reverse()
storySettings = storySettings[0]
let rawCredits;
try {
	rawCredits = require('../data/credits.sheet.json')
} catch (err){
    // It's fine
    rawCredits = null;
}
let related_links;
try{
  related_links = require('../data/links.sheet.json')
} catch(err){
  related_links = require('../data/sfc/related_links.json')
}

const IndexPage = ({ data }) => {
  console.log(page_list)
  const {
    site: { siteMetadata },
    allRelatedLinksJson: { nodes: relatedLinks },
  } = data

  let socialHTML = `
      <div class=${topperStyles.socialIcon}>
        <a
          title="Share via email"
          href="mailto:?subject=${siteMetadata.MAIN_DOMAIN}&body=${siteMetadata.PROJECT.DESCRIPTION}%0A%0A${siteMetadata.MAIN_DOMAIN}%2F${siteMetadata.PROJECT.SUBFOLDER}%2F${siteMetadata.PROJECT.SLUG}%2F">
          <svg
            width="100%"
            height="100%"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M3.00977 5.83789C3.00977 5.28561 3.45748 4.83789 4.00977 4.83789H20C20.5523 4.83789 21 5.28561 21 5.83789V17.1621C21 18.2667 20.1046 19.1621 19 19.1621H5C3.89543 19.1621 3 18.2667 3 17.1621V6.16211C3 6.11449 3.00333 6.06765 3.00977 6.0218V5.83789ZM5 8.06165V17.1621H19V8.06199L14.1215 12.9405C12.9499 14.1121 11.0504 14.1121 9.87885 12.9405L5 8.06165ZM6.57232 6.80554H17.428L12.7073 11.5263C12.3168 11.9168 11.6836 11.9168 11.2931 11.5263L6.57232 6.80554Z"
              fill="currentColor"
            />
          </svg>
        </a>
      </div>
      <div class=${topperStyles.socialIcon}>
        <a
          title="Share on Facebook"
          href="https://www.facebook.com/sharer/sharer.php?u=${siteMetadata.MAIN_DOMAIN}%2F${siteMetadata.PROJECT.SUBFOLDER}%2F${siteMetadata.PROJECT.SLUG}%2F"
          target="_blank"
          rel="noopener noreferrer"
        >
          <svg
            width="100%"
            height="100%"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.19795 21.5H13.198V13.4901H16.8021L17.198 9.50977H13.198V7.5C13.198 6.94772 13.6457 6.5 14.198 6.5H17.198V2.5H14.198C11.4365 2.5 9.19795 4.73858 9.19795 7.5V9.50977H7.19795L6.80206 13.4901H9.19795V21.5Z"
              fill="currentColor"
            />
          </svg>
        </a>
      </div>
      <div class=${topperStyles.socialIcon}>
        <a
          target="_blank"
          rel="noopener noreferrer"
          title="Share on Twitter"
          href="https://twitter.com/intent/tweet?url=${siteMetadata.MAIN_DOMAIN}%2F${siteMetadata.PROJECT.SUBFOLDER}%2F${siteMetadata.PROJECT.SLUG}%2F&text=${siteMetadata.PROJECT.TWITTER_TEXT}">
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 248 204" 
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
      <path
        data-name="Twitter Logo"
        fill="currentColor"
        d="M222 51.29c.15 2.16.15 4.34.15 6.52 0 66.74-50.8 143.69-143.69 143.69A142.91 142.91 0 0 1 1 178.82a102.72 102.72 0 0 0 12 .72 101.29 101.29 0 0 0 62.72-21.66 50.53 50.53 0 0 1-47.18-35.07 50.35 50.35 0 0 0 22.8-.86 50.53 50.53 0 0 1-40.52-49.5v-.64a50.25 50.25 0 0 0 22.92 6.32 50.55 50.55 0 0 1-15.6-67.42 143.38 143.38 0 0 0 104.08 52.77 50.55 50.55 0 0 1 86.06-46.06 101.19 101.19 0 0 0 32.06-12.26 50.66 50.66 0 0 1-22.2 27.93 100.89 100.89 0 0 0 29-7.94A102.84 102.84 0 0 1 222 51.29z"
      />
      </svg>
        </a>
      </div>`
  useEffect(() => {
    // Set up scroll analytics
    applyScrollDepthTracking()
  }, [])

  let today = new Date().getTime()
  // easy hooks based request library
  // const { data: responseData, error } = useSWR('https://api.kanye.rest', getData, {
  //   onSuccess: (data) => console.log(data),
  //   onError: (err) => console.log(err),
  // })

  // custom hook checks for nativelazyload
  const lazy = useCanNativeLazyLoad()

	//check if there's a sponsor
	const has_sponsor = (storySettings.Is_Sponsored === true || storySettings.Is_Sponsored === "TRUE")
  console.log(has_sponsor)


  function convertDatesToAP(dateString) {
    // Convert date string to AP style abbreviations
    let newDateString = dateString
    newDateString = newDateString
      .replace('January', 'Jan.')
      .replace('February', 'Feb.')
      .replace('August', 'Aug.')
      .replace('September', 'Sept.')
      .replace('October', 'Oct.')
      .replace('November', 'Nov.')
      .replace('December', 'Dec.')
      .replace('AM', 'a.m.')
      .replace('PM', 'p.m.')
    // Return the result
    return newDateString
  }

  const parseDate = (date) => {
    let parts = date.match(/(\d+)/g)
    let dateObject
    dateObject = new Date(parseInt(parts[0]), parseInt(parts[1] - 1), parseInt(parts[2]))
    let month
    try{
    month = convertDatesToAP(new Intl.DateTimeFormat('en-US', {month: 'long'}).format(dateObject))
    }
    catch(error){
      console.log(dateObject)
    }
    let day = dateObject.getDate()
    let year = dateObject.getFullYear()
    return('Week of ' + month + ' ' + day + ', ' + year)
  }
// console.log(storySettings.Hide_Page_Date)
let hidePageDate = storySettings.Hide_Page_Date === 'TRUE' || storySettings.Hide_Page_Date === true
// console.log(hidePageDate)
// for(let page of page_list){
//   console.log('page close date: ', Date.parse(new Date(page.Poll_Close)))
//   console.log('current system date: ', Math.floor(new Date(today).getTime()))
//   console.log('closed? ',  Date.parse(new Date(page.Poll_Close)) < today)
// }
// page_list.map((page) => console.log(Date.parse(new Date(page.Page_Date), today))

  return (
    <Layout meta={siteMetadata}>
      <NavTop />
       <header className={topperStyles.header}>
        <section
          aria-label="Topper headline, deck, byline and dateline"
          className={topperStyles.textContainer}
        >
          {storySettings.Kicker.length > 0 && <h2 className={topperStyles.kicker}>{storySettings.Kicker}</h2>}
          <h1 className={topperStyles.hed}>{storySettings.Title}</h1>
          <div className={topperStyles.dateby}>
          {storySettings.Byline.length > 0 &&  <span>By </span> }
          {storySettings.Byline.length > 0 && <span dangerouslySetInnerHTML={{__html: (GetBylineText(storySettings.Byline, storySettings.Byline_Link) + ' &nbsp;|&nbsp ')}}/>}
            <Fragment>
              <time className='topper-dateline' dateTime={storySettings.Publish_Date}>{storySettings.Publish_Date} </time>
            </Fragment>
          {moddateString && (
              <Fragment>
                <time
                  className="topper-dateline updated-date"
                  dateTime={storySettings.LastModDate_C2P}
                  itemProp="dateModified"
                >
                  | Updated: {moddateString}
                </time>
              </Fragment>
            )}
              
          </div>
          <div className={topperStyles.topsocial}
              dangerouslySetInnerHTML={{__html: socialHTML}}
            />

        </section>
      </header>
      <main>
				{has_sponsor && <SponsorBug />}
          <BodyText
          text = {storySettings.Intro_graf}
          />
          <div className='aotw-links'>
          {storySettings.switch_link_one && <SafeLink withinSite={false} href={storySettings.switch_link_one}>{storySettings.switch_link_one_text}</SafeLink>}
          {storySettings.voting_rules && <SafeLink withinSite={false} href={storySettings.voting_rules}>{storySettings.voting_rules_text}</SafeLink>}
          {storySettings.switch_link_two && <SafeLink withinSite={false} href={storySettings.switch_link_two}>{storySettings.switch_link_two_text}</SafeLink>}
          </div>
        {page_list.map((page) => <HubPageCard key={Date.parse(new Date(page.Page_Date))} hideDate={hidePageDate}slug={Date.parse(new Date(page.Page_Date))} name={page.Page_Title} pageDate={page.Page_Date} date_readable={parseDate(page.Page_Date)} voting_closed={ConvertTimestamp(new Date(page.Poll_Close).getTime()) < today ? true : false} winner_announced={page.winner_announced}/>)}
        <Ad adLetter={'A'} />
      </main>

      <RelatedSection links={related_links} />
      <CreditsSection />
    </Layout>
  )
}

export const query = graphql`
  {
    site {
      siteMetadata {
        EMBEDDED
        MAIN_DOMAIN
        PAYWALL_SETTING
        PROJECT {
          AUTHORS {
            AUTHOR_NAME
            AUTHOR_PAGE
          }
          DATE
          DESCRIPTION
          HEARST_CATEGORY
          KEY_SUBJECTS
          DISPLAY_TITLE
          IMAGE
          ISO_MODDATE
          ISO_PUBDATE
          OPT_SLASH
          SLUG
          SOCIAL_TITLE
          SUBFOLDER
          TITLE
          TWITTER_TEXT
          ANALYTICS_CREDIT
          MARKET_KEY
          CANONICAL_URL
        }
      }
    }
    allRelatedLinksJson {
      nodes {
        wcmid
        title
        url
      }
    }
  }
`
IndexPage.propTypes = {
  data: PropTypes.object.isRequired,
}

export default IndexPage
